module.exports = __webpack_public_path__ + "img/ic_store-owner.02ee3772.svg";